/* eslint-disable camelcase */
import {
  FETCH_BOOKMARKS_LIST,
  GET_DEFAULT_BOOKMARK,
  REMOVE_BOOKMARK,
  SET_BOOKMARK,
} from '../actions/types'
import { HouseCardItemProps } from './homeReducer'

export interface BookmarkStateProps {
  data: HouseCardItemProps[]
  loading: boolean
  pagination: any
}

interface BookmarkActionProps extends BookmarkStateProps {
  type: string
}

export const bookmarkReducer = (
  state: BookmarkStateProps = {
    data: [],
    loading: true,
    pagination: null,
  },
  { type, data, loading, pagination }: BookmarkActionProps,
): BookmarkStateProps => {
  switch (type) {
    case FETCH_BOOKMARKS_LIST:
      return {
        data,
        loading,
        pagination,
      }
    case SET_BOOKMARK:
      return { data, loading, pagination }
    case GET_DEFAULT_BOOKMARK:
      return {
        data,
        loading,
        pagination,
      }
    case REMOVE_BOOKMARK:
      return { data, loading, pagination }
    default:
      return state
  }
}
